<template>
	<div :class="{'nav-open': $sidebar.showSidebar}">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
        methods: {
            logout() {

            }
        }
	}
</script>



// WEBPACK FOOTER //
// App.vue?6816a9a1